import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { APP_CONFIG, IAppConfig } from './app/_shared/services/config/runtime-config.service';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
  enableProdMode();
}

bootstrap().catch(err => console.error(err));


async function bootstrap() {
  const configUrl = environment.debug ? 'https://localhost:5001/config' : '/config'; //TODO: Move to environment file
  console.log('$ Loading config from ', configUrl);
  console.log('Environment:', environment);
  const response = await fetch(configUrl);
  const config = await response.json() as IAppConfig;

  // Object.entries(config.themeVars).forEach(
  //   ([cssVar, value]) => document.documentElement.style.setProperty(`--${cssVar}`, value)
  // );

  console.log('$ Config loaded, starting Angular...', config);

  const providers = [
    { provide: APP_CONFIG, useValue: {...config, routes: [...config.routes]} },
  ];

  platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch(err => console.log(err));

}

const FAKE_PARAGON_ROUTE_CONFIG = {
  "id": "ai",
  "category": "ai",
  "displayName": "Paragon AI (Beta)",
  "displayInNav": true,
  "iconClass": "fa fa-wand-magic-sparkles",
  "roles": [
      "Region Manager",
      "Corporate",
      "System Analyst",
      "System Administrator"
  ],
  "defaultRoute": "/ai/new",
  "isStatic": true,
  "order": 7.5,
  "externalTool": null,
  "newTab": null,
  "disableForDealerGroups": null,
  "children": [
      {
          "parent": "/ai",
          "route": "new",
          "displayName": "My Chats",
          "isStatic": false,
          "iconClass": null,
          "roles": null,
          "breadcrumbHelpEnabled": null,
          "displayInNav": null,
          "routeData": null,
          "reportName": null
      }
  ]
};